import React, { useEffect, useState } from "react";
import { Grid, Hidden, Typography } from "@mui/material";
import { Img, Link } from "../../";
import { Breadcrumbs } from "../../../components/Breadcrumbs";
import { formatDate } from "../../../helpers";
import { PostType, TagType } from "../../../types";
import { useStyles } from "./Hero.styles";
import _ from "lodash"

interface HeroPostProps {
	post?: PostType
	tag?: TagType
}

export function HeroPost({ post, tag }: HeroPostProps) {
	const { classes } = useStyles()
	const [url, setUrl] = useState('')

	const {
		featuredImage,
		featuredImageAltText,
		authorName,
		created,
		htmlTitle,
	} = post || {}

	const {
		name: tagName
	} = tag || {}

	useEffect(() => {
		if (typeof window !== 'undefined')
			setUrl(window.location.href)
	}, [])

	// Popup window function
	function basicPopup(url: string) {
		const popupWindow = window.open(url, 'popUpWindow', 'height=500,width=500,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
	}

	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				{/* @ts-ignore */}
				<Hidden lgUp>
					<Grid item xs={12} style={{ marginBottom: 24, }}>
						<Breadcrumbs
							items={[
								{ to: "/blog/", label: "Volver" },
								{ to: "", label: htmlTitle || 'Sin especificar' },
							]}
							itemClassName={classes.breadCrumbItem}
						/>
					</Grid>
				</Hidden>
				<Grid item xs={12}>
					<Img
						src={featuredImage}
						alt={featuredImageAltText}
						className={classes.imageFeatured}
						loadingType='eager'
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography className={classes.dateAndAuthorContainer}>
						<Link to={`/blog/tag/${tagName || 'crédito'}`}>
							<span className={classes.dateAndAuthor}>{_.capitalize(tagName) || 'Sin especificar'}</span>
						</Link>
						<span style={{ margin: '0px 4px', color: '#8892A0' }} > | </span>
						<span className={classes.dateAndAuthor}> {formatDate(created) || 'Sin especificar'} </span>
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography
						variant="h1"
						color="primary"
						className={classes.title}
					>
						{htmlTitle}
					</Typography>
				</Grid>
			</Grid>
		</section>
	)
}